// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const { useIconWarning } = require('./context')

const bem = BemEntity('Icon')

function Icon({ id, forwardedRef, ...props }) {
  useIconWarning(id)
  return (
    tag('svg', {
      ...props,
      ref: forwardedRef,
      className: classNames(
        props.className,
        bem.block(id)
      )
    },
      tag('use', {
        xlinkHref: `#${id}`
      })
    )
  )
}

Icon.defaultProps = {
  'aria-hidden': true
}

if (__DEV__) {
  const PropTypes = require('prop-types')
  const morePropTypes = require('client-v2/common/utils/prop-types')

  Icon.propTypes = {
    className: PropTypes.string,
    forwardedRef: morePropTypes.domRef,
    id: PropTypes.string.isRequired
  }
}

module.exports = Icon
